var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-absen"},[_c('img',{staticClass:"close-foto-absensi",attrs:{"src":require("../../../assets/icons/close-white.svg"),"alt":""},on:{"click":_vm.back}}),_c('div',{staticClass:"foto-absensi",style:({backgroundImage: _vm.fotoAbsensi})})])
}
var staticRenderFns = []

export { render, staticRenderFns }